<template>
	<div id="app">
		<el-container>
			<el-header class="div-header">
				<Header />
				<el-divider class="header-divider"></el-divider>
			</el-header>

			<div class="main-div">
				<el-container class="main-div parentDiv">
					<splitpanes class="default-theme defaultStyle custom-splite">
						<pane size="100" class="SideBarLeft">
               <!--SID1037 Body Part -->
							<template>
								<el-container class="SID0014__InquiryCondition0014">
									<div class="SID0014__Container">
										<!-- Breadcrumb section -->
									<el-breadcrumb separator-class="el-icon-arrow-right">
										<el-breadcrumb-item :to="{ path: '0002' }">トップ(記事一覧)</el-breadcrumb-item>
										<el-breadcrumb-item :to="{ path: '' }">原文利用実績：照会条件設定</el-breadcrumb-item>
									</el-breadcrumb>
										<el-container>
											<div class="resultDiv">
												<el-form ref="form" :rules="rules"  :model="form" class="div-result" label-width="auto">
													<el-form-item label="集計条件 ">
														<!-- Change CK for Backlog-comment:1592 changed usergroubid to usergroupname -->
														<span>ユーザグループID {{ this.getUserGroupName }} (ユーザID：{{ this.getUserId }})</span>
													</el-form-item>
													<el-form-item label="集計期間" prop="range">
                                                    <v-date-picker
                                                    mode='range'
													:masks="{ title: 'YYYY年MMM' }"
                                                    v-model='form.range'
													locale="ja"
													show-caps
													:popover="{  visibility: 'click' }">
													<input slot-scope="{ inputProps, inputEvents }"          
													v-bind="inputProps"
													v-on="inputEvents" />
                                                    </v-date-picker>  
                                                    </el-form-item>
													<el-form-item>
                                                        <div class="ButtonDiv">
                                                            <el-button type="primary" @click="goto0015('form')"  plain>照会</el-button>
                                                        </div>
                                                    </el-form-item>
												</el-form>
											</div>
										</el-container>

										
										
									</div>
								</el-container>
							</template>
              <!--SID1037 Body Part End-->
						</pane>
						<pane class="SideBarRight">
							<SideBar class="SidePane" />
						</pane>
					</splitpanes>
				</el-container>
			</div>

			<el-container class="footer-div">
				<el-footer class="footer-element">
					<FooterComponent />
				</el-footer>
			</el-container>
		</el-container>
	</div>
</template>

<script>
import Header from "../common/header.vue";
import SideBar from "../common/side-bar.vue";
import FooterComponent from "../common/footerComponent.vue";
import { mapGetters } from "vuex";
import router from '../../router';
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";

var CurrentYear = new Date().getFullYear();
var CurrentMonth = new Date().getMonth();
var CurrentDay = new Date().getDate();
var EndDay = 0;
var StartDay = 0;  
var PreviousMonth;

var Month;
//if current date is 01, start date is first date of previous month and end date is last date of previous month
if(CurrentDay == 1)
{
	StartDay = 1;
	PreviousMonth = CurrentMonth - 1;
	EndDay = 0;
	Month = CurrentMonth;
}
else
{
	
	//else start date is first date of previous month and end date is first date of current month
	StartDay = 1;
	EndDay = CurrentDay - 1;
	PreviousMonth = CurrentMonth;
	Month = CurrentMonth;
}

export default {
	name: "SID0014",
	components: {
		Header,
		SideBar,
		FooterComponent,
		Splitpanes,
		Pane
	},
	data() {
		var checkdate = (rule, value, callback) => {
		var date_select = this.form.range.start;
		var todaydate=new Date();
		if (date_select > todaydate) {
			callback(new Error("集計期間は正しい日付を入力してください。"));
		} else {
			callback();
		}
		};
		return {
			form: {
				range: {
					start: new Date(CurrentYear, PreviousMonth, StartDay), // Jan 16th, 2018
					end: new Date(CurrentYear, Month, EndDay) // Jan 19th, 2018
				},
			},
			userGroupName: this.getUserGroupName,
			
				date: new Date(),
            rules: {
             range: [
				{ required: true, message: '集計期間を指定してください。', trigger: 'blur'},
				{ validator:checkdate,message:'集計期間は正しい日付を入力してください。', trigger: 'change'}
            ]
        }
		};
	},
	computed: {
		...mapGetters("situation0001", [     
            "getUserId",
            "getUserGroupId",
            "getUserGroupName"
        ]) 
	},
	mounted(){
		
	},
	methods: {
		goto0015(formName) {
			this.$LogButtonEvent("0014","Inquiry");
			this.$LogMethodIN("0014","goto0015");
			this.$refs[formName].validate((valid) => {
					if(valid)
					{
						var aggregation_period_date=this.form.range;
						//To get the start date
						var getStartDate=aggregation_period_date.start;
							var splitData = new Date(getStartDate),
							splitmonth = ("0" + (splitData.getMonth() + 1)).slice(-2),
							splitday = ("0" + splitData.getDate()).slice(-2);
							var startResult = [splitData.getFullYear(), splitmonth, splitday].join("/");
						//To get the end date
						var getlastDate=aggregation_period_date.end;
						var splitDataLast = new Date(getlastDate),
						splitmonthlast = ("0" + (splitDataLast.getMonth() + 1)).slice(-2),
						splitdaylast = ("0" + splitDataLast.getDate()).slice(-2);
						var endResultlast = [splitDataLast.getFullYear(), splitmonthlast, splitdaylast].join("/");
						var aggregationPeriod;
						aggregationPeriod = startResult + ' ~ ' + endResultlast;
						var sent_data={
							AggregationconditionUser_group:this.userGroupName,
							AggregationconditionUser_id:this.userId,
							startDate:startResult,
							endDate:endResultlast

						}
						router.push({
						name: "SID0015",
						params: {
							data:sent_data
							}
						});
						this.$store.commit('situation0015/setAggregationcondition', aggregationPeriod);
           
						
					}
					else
					{
						
						return false;
					}});
					this.$LogMethodOut("0014","goto0015");
			}
           
          
       
		},
		beforeCreate(){
	//Common.Session.CheckSessionExists_IfExpired_GoToLogout();
	//Common.Session.CheckIsMobile("sp/0014","/0014"); // MobileScreen Path, WebScreen Path
    },

};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "0014.css";
</style>